import { invalidateMenuCache } from '@fff-web/fff-global-nav';
import { invalidateUserCache } from '@fff-web/fff-utilities';
import { syncDelay } from './index';

const invalidateCaches = () => {
  invalidateUserCache();
  syncDelay(1000);
  invalidateMenuCache();
  syncDelay(4000);
};

export default invalidateCaches;
